const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const formatMessage = require('format-message');
const axios = require('axios');
const codeGeneration = require('../codeGeneration');

let setupCode = '';
let defineCode = '';
let loopCode = '';
let bodyCode = '';
const initializedPins = new Set(); // To track initialized pins
const definedFunctions = new Set();
const definedVariable = new Set();

class Scratch3SensorsBlocks {
    constructor (runtime) {
        this.runtime = runtime;
        this.lastThread = null;
    }

    _checkNewThread (util) {
        const thread = util && util.thread;
        if (thread && this.lastThread !== thread) {
            this.lastThread = thread;
            initializedPins.clear();
            definedFunctions.clear();
            definedVariable.clear();
        }
    }

    getInfo () {
        return {
            id: 'sensors',
            name: 'Sensors',
            color1: '#18b3d6',

            blocks: [
                {
                    opcode: 'disSensor',
                    blockType: BlockType.COMMAND,
                    text: 'Connect Ultrasonic sensor with pin [trigdisPin] and [echoPin]',
                    arguments: {
                        trigdisPin: {
                            type: ArgumentType.STRING,
                            defaultValue: '9' // Default pin for trig
                        },
                        echoPin: {
                            type: ArgumentType.STRING,
                            defaultValue: '8' // Default pin for echo
                        }
                    },
                    func: 'disSensor' // Link to the function

                },
                {
                    opcode: 'acvtDissensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.acvtDissensor',
                        default: 'Check distane and store the value in [varname] in [distancecm]',
                        description: 'Check the distance'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        distancecm: {
                            type: ArgumentType.STRING,
                            defaultValue: 'CM',
                            menu: 'distanceMenu'
                        }
                    }
                },
                {
                    opcode: 'checkdistance',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'sensor.disCheck',
                        default: 'distance of [varname] [operator] [number]',
                        description: 'Check Varaible'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        operator: {
                            type: ArgumentType.STRING,
                            menu: 'operatorMenu',
                            defaultValue: '=='
                        },
                        number: {
                            type: ArgumentType.STRING,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'cntobsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.cntabsensor',
                        default: 'Connect IR Sensor [number] in pin [pin]',
                        description: 'connect to obstacle sensor'
                    }),
                    arguments: {
                        number: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        pin: {
                            type: ArgumentType.STRING,
                            defaultValue: '6'
                        }
                    }
                },
                {
                    opcode: 'acvtIrsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.acvtIrsensor',
                        default: 'Check obstacle form IR Sensor [num] and store the value in [varname]',
                        description: 'Check the obstacles'
                    }),
                    arguments: {
                        num: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        }
                    }
                },
                {
                    opcode: 'checkobs',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'sensor.checkobs',
                        default: ' presence of obstacle in [varname] == [number]',
                        description: 'Check Varaible'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'yesnoMenu',
                            defaultValue: 'yes'
                        }
                    }
                },
                {
                    opcode: 'cntFiresensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.cntFiresensor',
                        default: 'Connect fire sensor',
                        description: 'connect to fire sensor'
                    })
                },
                {
                    opcode: 'acvtFiresensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.acvtFirersensor',
                        default: 'Check for fire and store the value in [varname]',
                        description: 'Check for fire'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        }
                    }
                },
                {
                    opcode: 'checkfire',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'sensor.checkfire',
                        default: ' presence of fire in [varname] == [number]',
                        description: 'Check Varaible'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'yesnoMenu',
                            defaultValue: 'yes'
                        }
                    }
                },
                {
                    opcode: 'cntlightsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.cntlightsensor',
                        default: 'Connect light sensor [number] in pin [pin]',
                        description: 'connect to light sensor'
                    }),
                    arguments: {
                        number: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        pin: {
                            type: ArgumentType.STRING,
                            defaultValue: '6'
                        }
                    }
                },
                {
                    opcode: 'acvtLightsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'sensor.acvtLightsensor',
                        default: 'Check light form sensor [num] and store the value in [varname]',
                        description: 'Check the obstacles'
                    }),
                    arguments: {
                        num: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        }
                    }
                },
                {
                    opcode: 'checklight',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'sensor.checklight',
                        default: ' presence of light in [varname] == [number]',
                        description: 'Check Varaible'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'yesnoMenu',
                            defaultValue: 'yes'
                        }
                    }
                }
            ],
            menus: {
                operatorMenu: {
                    items: ['==', '>', '<', '<=', '>=', '!=']
                },
                yesnoMenu: {
                    items: ['yes', 'no']
                },
                distanceMenu: {
                    items: ['MM', 'CM', 'INCH']
                }
            }
        };
    }

    // Function to handle distance sensor initialization
    disSensor (args, util) {
        this._checkNewThread(util);
        const trigdisPin = args.trigdisPin;
        const echoPin = args.echoPin;
        // Initialize the pins in setup code if not already done
        if (!initializedPins.has('trigdisPin')) {
            defineCode += `#define trigPin ${trigdisPin}\n`;
            setupCode += 'pinMode(trigPin, OUTPUT);\n';
            initializedPins.add('trigdisPin');
        }
        if (!initializedPins.has('echoPin')) {
            defineCode += `#define echoPin ${echoPin}\n`;
            setupCode += 'pinMode(echoPin, INPUT);\n';
            initializedPins.add('echoPin');
        }
        this.accumulateCode(util);
        // Optionally, reset the setup code for subsequent blocks
        this.resetCode();
    }

    acvtDissensor (args, util) {
        this._checkNewThread(util);
        const varname = args.varname || 'distanceValue';
        const distanceUnit = args.distancecm || 'CM';

        let conversionCode = '';

        switch (distanceUnit) {
        case 'MM':
            conversionCode = 'distance = distance * 10;';
            break;
        case 'INCH':
            conversionCode = 'distance = distance / 2.54;';
            break;
        case 'CM':
        default:
            conversionCode = '';
            break;
        }

        if (!definedFunctions.has(`distance_check_${distanceUnit}`)) {
            bodyCode += `
                float distance_check_${distanceUnit}() {
                    float duration, distance;

                    digitalWrite(trigPin, LOW);
                    delayMicroseconds(2);
                    digitalWrite(trigPin, HIGH);
                    delayMicroseconds(10);
                    digitalWrite(trigPin, LOW);

                    duration = pulseIn(echoPin, HIGH);

                    // Distance in CM
                    distance = (duration * 0.0343) / 2;

                    ${conversionCode}

                    delay(100);
                    return distance;
                }\n`;
        }

        definedFunctions.add(`distance_check_${distanceUnit}`);

        if (!definedVariable.has(varname)) {
            defineCode += `float ${varname};\n`;
            loopCode += `${varname} = distance_check_${distanceUnit}();\n`;
            definedVariable.add(varname);
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    checkdistance (block) {
        const variable = block.varname;
        const number = block.number;
        const operator = block.operator;

        // Generate the condition for the if block
        return `${variable} ${operator} ${number}`;
    }
    cntobsensor (args, util) {
        this._checkNewThread(util);
        const sensorNumber = args.number;
        const pinNumber = args.pin;

        // Initialize the pins in setup code if not already done
        if (!initializedPins.has(`ir_sensor_${sensorNumber}`)) {
            defineCode += `#define IR_SENSOR_${sensorNumber} ${pinNumber}\n`;
            setupCode += `pinMode(IR_SENSOR_${sensorNumber}, INPUT);\n`;
            initializedPins.add(`ir_sensor_${sensorNumber}`);
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    acvtIrsensor (args, util) {
        this._checkNewThread(util);
        const sensorNum = args.num;
        const varname = args.varname;

        // Add the variable declaration and reading from the specific sensor
        if (!definedVariable.has(varname)) {
            defineCode += `int ${varname};\n`;
            loopCode += `${varname} = digitalRead(IR_SENSOR_${sensorNum});\n`;
            definedVariable.add(varname);
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    checkobs (block) {
        const variable = block.varname;
        let number = block.number;
        if (number === 'no') {
            number = 1;
        } else if (number === 'yes') {
            number = 0;
        }

        // Generate the condition for the if block
        return `${variable} == ${number}`;
    }
    cntFiresensor (args, util) {
        this._checkNewThread(util);
        // Initialize the pins in setup code if not already done
        if (!initializedPins.has('trigirPin')) {
            defineCode += '#define _fire_ 32\n';
            setupCode += 'pinMode(_fire_, INPUT);\n';
            initializedPins.add('trigirPin');
        }
        this.accumulateCode(util);
        // Optionally, reset the setup code for subsequent blocks
        this.resetCode();
    }
    acvtFiresensor (args, util) {
        this._checkNewThread(util);
        const varname = args.varname;
        // Add the call to distance_check in the loop code, using the variable name provided in args
        if (!definedVariable.has(varname)) {
            defineCode += `int ${varname};`;
            loopCode += `${varname} = digitalRead(_fire_);\n`;
        }
        definedVariable.add(varname);
        this.accumulateCode(util);
        // Optionally, reset the setup code for subsequent blocks
        this.resetCode();
    }
    checkfire (block) {
        const variable = block.varname;
        let number = block.number;
        if (number === 'no') {
            number = 1;
        } else if (number === 'yes') {
            number = 0;
        }

        // Generate the condition for the if block
        return `${variable} == ${number}`;
    }

    cntlightsensor (args, util) {
        this._checkNewThread(util);
        const sensorNumber = args.number;
        const pinNumber = args.pin;

        // Initialize the pins in setup code if not already done
        if (!initializedPins.has(`ir_sensor_${sensorNumber}`)) {
            defineCode += `#define LDR_SENSOR_${sensorNumber} ${pinNumber}\n`;
            setupCode += `pinMode(LDR_SENSOR_${sensorNumber}, INPUT);\n`;
            initializedPins.add(`ldr_sensor_${sensorNumber}`);
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    acvtLightsensor (args, util) {
        this._checkNewThread(util);
        const sensorNum = args.num;
        const varname = args.varname;

        // Add the variable declaration and reading from the specific sensor
        if (!definedVariable.has(varname)) {
            defineCode += `int ${varname};\n`;
            loopCode += `${varname} = digitalRead(LDR_SENSOR_${sensorNum});\n`;
            definedVariable.add(varname);
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    checklight (block) {
        const variable = block.varname;
        let number = block.number;
        if (number === 'no') {
            number = 1;
        } else if (number === 'yes') {
            number = 0;
        }

        // Generate the condition for the if block
        return `${variable} == ${number}`;
    }

    accumulateCode (util) {
        codeGeneration.accumulateCode(defineCode, bodyCode, setupCode, loopCode, util);
    }
    // Method to reset code variables if needed
    resetCode () {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
    }
    full_reset () {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
        initializedPins.clear();
        definedFunctions.clear();
        definedVariable.clear();
    }
}

module.exports = Scratch3SensorsBlocks;
